import React from "react";

import PropTypes from "prop-types";

import RbCheckboxGroupControl from "../RbCheckboxGroupControl";
import RbField from "../RbField";

function RbCheckboxGroupField(props) {
  const { fieldName, required, ...other } = props;

  const validate = React.useCallback(
    (value) => {
      if ((!value || value.length === 0) && required) {
        return "Required field";
      }

      return undefined;
    },
    [required]
  );

  return (
    <RbField
      Component={RbCheckboxGroupControl}
      defaultEmptyValue={null}
      fieldName={fieldName}
      required={required}
      validate={validate}
      {...other}
    />
  );
}

RbCheckboxGroupField.propTypes = {
  fieldName: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

RbCheckboxGroupField.defaultProps = {
  required: undefined,
};

export default React.memo(RbCheckboxGroupField);
